module.exports = __webpack_public_path__ + "static/img_pinterest-15f8d126bae79bbced8d2bb8e54ba53d.webp";